/**
 * Backend'den gelen objenin anahtarlarını büyük harfe çevirir (PostgreSQL lowercase dönebilir).
 * Carisatis cache/form uyumu için kullanılır.
 */
export function normalizeKeysToUpper(obj) {
  if (!obj || typeof obj !== 'object') return obj;
  const out = {};
  for (const k of Object.keys(obj)) {
    out[k.toUpperCase()] = obj[k];
  }
  return out;
}

export function normalizeListToUpper(arr) {
  return Array.isArray(arr) ? arr.map(normalizeKeysToUpper) : arr;
}
